import { useEffect, useState } from 'react';

const navLinks = [
  { label: '首页', href: '#top' },
  { label: '人气排行', href: '#ranking' },
  { label: '作品分类', href: '#categories' },
  { label: '同好推荐', href: '#recommend' },
  { label: '读者口碑', href: '#reputation' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 md:h-20 items-center justify-between px-4 md:px-6 lg:px-10">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-xl"></i>
          </span>
          <span className="font-heading text-lg md:text-xl font-bold text-foreground-900">
            御宅书屋
          </span>
        </a>

        <ul className="hidden md:flex items-center gap-1 lg:gap-2">
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="px-3 lg:px-4 py-2 rounded-full text-sm font-medium text-foreground-800 hover:bg-secondary-100 hover:text-foreground-950 transition whitespace-nowrap"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="hidden md:flex items-center gap-2">
          <a
            href="#recommend"
            className="flex h-10 items-center gap-2 rounded-full bg-primary-500 px-5 text-sm font-medium text-background-50 transition hover:bg-primary-600 whitespace-nowrap"
          >
            <i className="ri-quill-pen-line"></i>
            写书评
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-foreground-800 md:hidden"
        >
          <i className={`text-xl ${open ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </nav>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 hover:bg-secondary-100"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="#recommend"
            onClick={() => setOpen(false)}
            className="mt-2 flex h-10 items-center justify-center gap-2 rounded-lg bg-primary-500 text-sm font-medium text-background-50"
          >
            <i className="ri-quill-pen-line"></i>
            写书评
          </a>
        </div>
      )}
    </header>
  );
}